"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderByNullsLast = exports.orderByNullsFirst = void 0;
var isNullish = function (value) { return value === null || typeof value === 'undefined'; };
var getOrderBy = function (nulls) { return function (_input, _expression) {
    if (_input && _expression) {
        var input = __spreadArray([], _input, true);
        var getSorter = function (direction, expression) {
            if (expression === void 0) { expression = _expression; }
            return function (a, b) {
                if (isNullish(a[expression]) && !isNullish(b[expression])) {
                    return nulls === 'NULLS_FIRST' ? -1 : 1;
                }
                if (isNullish(b[expression]) && !isNullish(a[expression])) {
                    return nulls === 'NULLS_FIRST' ? 1 : -1;
                }
                if (a[expression] > b[expression]) {
                    return 1 * direction;
                }
                if (b[expression] > a[expression]) {
                    return -1 * direction;
                }
                return 0;
            };
        };
        if (_expression.startsWith('-')) {
            return input.sort(getSorter(-1, _expression.slice(1)));
        }
        return input.sort(getSorter(1));
    }
    return _input;
}; };
exports.orderByNullsFirst = getOrderBy('NULLS_FIRST');
exports.orderByNullsLast = getOrderBy('NULLS_LAST');
//# sourceMappingURL=index.js.map